import React, {createContext, useContext} from 'react';
import {useDispatch} from 'react-redux';
import PropTypes from 'prop-types';
import {FormikProvider, useFormik} from "formik";
import * as actions from '../../_redux/actions/OrdersPageTableActions';

const PopupEditPaidContext = createContext('');

export function usePopupEditPaidContext() {
  return useContext(PopupEditPaidContext);
}

export function PopupEditPaidContextProvider({children, paid, orderID, handleCloseModal}) {
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(actions.editPaid({
      orderID,
      paid: formik.values.paid,
    }));
    handleCloseModal();
  }

  const formik = useFormik({
    initialValues: {paid},
    onSubmit: () => {},
    validateOnMount: true,
    validateOnBlur: true,
    enableReinitialize: true,
  });

  return (
    <PopupEditPaidContext.Provider value={{formik, handleEdit, handleCloseModal}}>
      <FormikProvider value={formik}>
        {children}
      </FormikProvider>
    </PopupEditPaidContext.Provider>
  );
}

PopupEditPaidContextProvider.propTypes = {
  children: PropTypes.node,
};
